const initialState = {
  layoutstyledata: localStorage.getItem("layoutStyling"),
  selectedClients: [],
  selectedBrands: [],
  clients: [],

  auth: {
    token: localStorage.getItem("accessToken") || null,
    isAuthenticated: !!localStorage.getItem("accessToken"),
    expirationTime: null,
  },

  // User permissions for route access control
  permissions: {
    routes: [],
    role: null,
    hasAllPermissions: false,
    loaded: false,
    page_permissions: {},
  },
  profile: {
    id: null,
    last_login: null,
    is_superuser: false,
    username: null,
    first_name: null,
    last_name: null,
    email: null,
    is_staff: false,
    is_active: false,
    date_joined: null,
    role: null,
    phone_number: null,
    page_permissions: {},
    client_permissions: [],
    page_authorization: [],
    user_group: null,
    groups: [],
    user_permissions: [],
  },
};

export default initialState;
